(function () {
  // Optional: disable on small screens
  if (window.innerWidth < 768) return;

  const snowEmojis = ['❄️', '❅', '❆'];

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.style.position = 'fixed';
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = 9999;

  document.body.appendChild(canvas);

  let width, height;
  function resize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  const flakes = [];
  const FLAKE_COUNT = 60;

  for (let i = 0; i < FLAKE_COUNT; i++) {
    flakes.push(createFlake());
  }

  function createFlake() {
    return {
      x: Math.random() * width,
      y: Math.random() * height,
      size: Math.random() * 18 + 14,
      speedY: Math.random() * 0.8 + 0.4,
      speedX: Math.random() * 0.6 - 0.3,
      opacity: Math.random() * 0.5 + 0.5,
      emoji: snowEmojis[Math.floor(Math.random() * snowEmojis.length)]
    };
  }

  function animate() {
    ctx.clearRect(0, 0, width, height);

    flakes.forEach(f => {
      ctx.globalAlpha = f.opacity;
      ctx.font = `${f.size}px serif`;
      ctx.fillText(f.emoji, f.x, f.y);

      f.y += f.speedY;
      f.x += f.speedX;

      if (f.y > height + 20) {
        f.y = -20;
        f.x = Math.random() * width;
      }
      if (f.x > width || f.x < -20) {
        f.x = Math.random() * width;
      }
    });

    requestAnimationFrame(animate);
  }

  animate();
})();
